<script setup lang="ts">
import ExchangeCoinsPage from '../index.vue'
</script>

<template>
  <ExchangeCoinsPage />
</template>
